// (function () {
// 	'use strict';

//     const module = angular.module('imApp');

//     module.component('brReg', {
//         templateUrl: 'views/components/views/brReg/brReg.template.html?v=' + module.version,
// 		controllerAs: 'vm',
//         controller: ['utilityService', 'base64', 'brRegService', function (utilityService, base64, brRegService) {
			
//             // #region VARIABLES & DEFINITIONS

//             const vm = this;

// 			vm.model = {
//                 companyNameSearchButtons: [
//                     { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('companyname_search') },
//                     { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => executeBrReg() }
//                 ],
//                 naeringsKodeButtons: [
//                     { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('naeringskode') }
//                 ],
//                 naeringsKodeButtons2: [
//                     { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('naeringskode') }
//                 ],
// 				countyButtons: [
//                     { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('county_id') }
// 				],
//                 communityButtons: [
//                     { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('comunity_id') }
//                 ],
// 				setting: {},
// 				selectListNaces: [],
// 				selectListCounties: [],
// 				selectListCommunities: [],
// 				itemsListCompanies: [],
// 				loadingCompanies: false
// 			};

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadSetting() {
//                 vm.model.setting = (await brRegService.getSetting())[0];
//             }

//             async function loadNaces() {
//                 vm.model.selectListNaces = await brRegService.listNaces();
//             }

//             async function loadCounties() {
//                 vm.model.selectListCounties = await brRegService.listCounties();
//             }

//             async function loadCommunities() {
//                 if (utilityService.validateParmsValue(vm.model.setting.county_id) !== true) return;

//                 return vm.model.selectListCommunities = await brRegService.listCommunities({ county_id: vm.model.setting.county_id });
// 			}

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region RESET BUTTON FUNCTION

//             function clear(id) {
//                 switch (id) {
//                     case 'naeringskode':
//                     case 'comunity_id':
//                         vm.model.setting[id] = '';
//                         break;
//                     case 'county_id':
//                         vm.model.setting.county_id = '';
//                         vm.model.setting.comunity_id = '';
//                         vm.model.selectListCommunities = [];
//                         break;
//                     case 'companyname_search':
//                         vm.model.setting.companyname_search = '';
//                         vm.model.itemsListCompanies = [];
//                         break;
//                     default:
//                         break;
//                 }
//             }

//             // #endregion RESET BUTTON FUNCTION

//             // #region SEARCH FUNCTION

//             vm.searchItems = function () {
//                 executeBrReg();
//             }

//             // #endregion SEARCH FUNCTION

//             // #region ON CHANGE FUNCTION

// 			vm.onCountyChanged = function (value) {
// 				vm.model.setting.county_id = value;

// 				if (value) loadCommunities();
// 			}

//             // #endregion ON CHANGE FUNCTION

// 			// #region EXECUTE FUNCTIONS

// 			vm.getUrl = function () {
//                 brRegService.getBrRegUrl(vm.model.setting).then(function (response) {
//                     vm.model.loadingCompanies = true;

//                     var searchUrl = response[0].search_url;
//                     var xhr = new XMLHttpRequest();

//                     xhr.open('GET', searchUrl, true);
//                     xhr.send();
//                     xhr.onreadystatechange = processRequest;

//                     function processRequest(e) {
//                         if (xhr.readyState == 4 && xhr.status == 200) {
//                             var response = xhr.responseText;
                            
//                             brRegService.listCompanies({ response: base64.urlencode(response) }).then((list) => {
// 							    vm.model.loadingCompanies = false;
//                                 vm.model.itemsListCompanies = list;
//                             });
// 						}
// 					}
// 				});
// 			}

//             function executeBrReg() {
// 				var companySearch = 'https://data.brreg.no/enhetsregisteret/api/enheter?navn=' + vm.model.setting.companyname_search;
// 				var xhr = new XMLHttpRequest();

// 				//xhr.open('GET', "https://ipinfo.io/json", true);
// 				xhr.open('GET', companySearch, true);
// 				xhr.send();
// 				xhr.onreadystatechange = processRequest;

// 				function processRequest(e) {
// 					if (xhr.readyState == 4 && xhr.status == 200) {
// 						var response = xhr.responseText;
						
//                         brRegService.listCompanies({ response: base64.urlencode(response) }).then((list) => {
//                             vm.model.itemsListCompanies = list;
//                         });
// 					}
// 				}
//             }

//             // #endregion EXECUTE FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 await loadSetting();
//                 loadNaces();
//                 loadCounties();
//                 loadCommunities();
//                 executeBrReg();
//             }

//             // #endregion ON INIT FUNCTION

// 		}]
// 	});
// })();
